// Google Analytics and AdSense Configuration from Environment Variables
export const ADS_CONFIG = {
  // Google Analytics Measurement ID
  GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX',

  // Google AdSense Publisher ID
  ADSENSE_PUBLISHER_ID: import.meta.env.VITE_ADSENSE_PUBLISHER_ID || 'ca-pub-YOUR_PUBLISHER_ID',

  // AdSense Ad Slot IDs
  AD_SLOTS: {
    HEADER: import.meta.env.VITE_ADSENSE_SLOT_HEADER || '1234567890',
    SIDEBAR: import.meta.env.VITE_ADSENSE_SLOT_SIDEBAR || '1234567891',
    IN_CONTENT: import.meta.env.VITE_ADSENSE_SLOT_IN_CONTENT || '1234567892',
    RESPONSIVE: import.meta.env.VITE_ADSENSE_SLOT_RESPONSIVE || '1234567893',
    FOOTER: import.meta.env.VITE_ADSENSE_SLOT_FOOTER || '1234567894',
  },

  // Feature flags
  ENABLE_ADS: import.meta.env.VITE_ENABLE_ADS === 'true' || import.meta.env.PROD,
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true' || import.meta.env.PROD,
}

// Helper function to get AdSense script URL
export const getAdSenseScriptUrl = () => {
  return `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_CONFIG.ADSENSE_PUBLISHER_ID}`
} 